import { render, staticRenderFns } from "./OMDesignWrapper.vue?vue&type=template&id=bcb254ac"
import script from "./OMDesignWrapper.vue?vue&type=script&lang=js"
export * from "./OMDesignWrapper.vue?vue&type=script&lang=js"
import style0 from "./OMDesignWrapper.vue?vue&type=style&index=0&id=bcb254ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports